import { render } from "./Footer.vue?vue&type=template&id=5c436519"
const script = {}

import exportComponent from "D:\\Projects\\2024\\Project_Algo\\aseansc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__